import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../utils/translator.helper';

export function activeDirectoryUsername(value: string): ValidationResult {
  let username = '';
  let domain = '';

  do {
    // test @ format
    const arondPosition = value.lastIndexOf('@');
    if (arondPosition !== -1) {
      username = value.substr(0, arondPosition);
      domain = value.substr(arondPosition + 1);
      break;
    }

    // test \ format
    const slashPosition = value.indexOf('\\');
    if (slashPosition !== -1) {
      domain = value.substr(0, slashPosition);
      username = value.substr(slashPosition + 1);
      break;
    }
  } while (false);

  // basic check for components
  if (!username || !domain) {
    return {
      valid: false,
      error: translateFn('Invalid username'),
    };
  }

  // validate username
  // invalid chars: " / \ [ ] : ; | = , + * ? < >
  const usernameRegex = new RegExp(/^[^\\\/\"\[\]\:\|\<\>\+\=\;\,\?\*\@]{1,104}$/i);
  if (!usernameRegex.test(username)) {
    return {
      valid: false,
      error: translateFn('Invalid username'),
    };
  }

  // validate FQDN
  const fqdnRegex = new RegExp(/^[a-z0-9][a-z0-9-\._]{0,251}[a-z0-9]$/i);
  if (!fqdnRegex.test(domain)) {
    return {
      valid: false,
      error: translateFn('Invalid username'),
    };
  }

  return { valid: true };
}
